import { MRT_Header, MRT_TableInstance } from "material-react-table";
import { Data } from "../Table";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import ClearIcon from "@mui/icons-material/Clear";

type Props = {
  header: MRT_Header<Data>;
  table: MRT_TableInstance<Data>;
};

export function RangeDataFilter({ header }: Props) {
  dayjs.locale("pt-br");
  const { column } = header;
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);

  const handleFromDateChange = (newValue: Dayjs | null) => {
    const date = newValue?.toDate();
    if (dayjs(date).isValid() && date && date?.getFullYear() >= 1000) {
      setFromDate(newValue);
      column.setFilterValue({ from: newValue, to: toDate });
    }
  };

  const handleToDateChange = (newValue: Dayjs | null) => {
    const date = newValue?.toDate();
    if (dayjs(date).isValid() && date && date?.getFullYear() >= 1000) {
      setToDate(newValue);
      column.setFilterValue({ from: fromDate, to: newValue });
    }
  };

  const clearFromDate = () => {
    setFromDate(null);
    column.setFilterValue({ from: null, to: toDate });
  };

  const clearToDate = () => {
    setToDate(null);
    column.setFilterValue({ from: fromDate, to: null });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Box sx={{ position: "relative", width: "175px" }}>
        <DatePicker
          label="Data mínima"
          value={fromDate}
          onChange={handleFromDateChange}
          slots={{
            textField: (params) => (
              <TextField
                {...params}
                placeholder="Selecione a data mínima"
                fullWidth
                variant="standard"
                slotProps={{
                  input: {
                    disableUnderline: true,
                  },
                }}
                sx={{
                  width: "175px",
                  "& .MuiInputBase-root": {
                    position: "relative",
                    marginTop: "0",
                  },
                  "& .MuiIconButton-edgeEnd": {
                    position: "absolute",
                    right: "20px",
                  },
                  "& .MuiInputBase-input": {
                    paddingRight: "60px",
                  },
                  "& .MuiInputLabel-root": {
                    opacity: fromDate || params.focused ? 0 : 1,
                    transition: "opacity 0.3s",
                    top: "-16px",
                  },
                  "& .MuiInputLabel-shrink": {
                    display: "none",
                  },
                }}
              />
            ),
          }}
          disableFuture
          format="DD/MM/YYYY"
        />
        {fromDate && (
          <IconButton
            size="small"
            onClick={clearFromDate}
            sx={{
              position: "absolute",
              top: "50%",
              right: "40px",
              transform: "translateY(-50%)",
              background: "transparent",
              zIndex: 2,
            }}
          >
            <ClearIcon />
          </IconButton>
        )}
      </Box>

      <Box sx={{ position: "relative", width: "175px" }}>
        <DatePicker
          label="Data máxima"
          value={toDate}
          onChange={handleToDateChange}
          slots={{
            textField: (params) => (
              <TextField
                {...params}
                placeholder="Selecione data final"
                fullWidth
                variant="standard"
                slotProps={{
                  input: {
                    disableUnderline: true,
                  },
                }}
                sx={{
                  width: "175px",
                  "& .MuiInputBase-root": {
                    position: "relative",
                    marginTop: "0",
                  },
                  "& .MuiIconButton-edgeEnd": {
                    position: "absolute",
                    right: "20px",
                  },
                  "& .MuiInputBase-input": {
                    paddingRight: "60px",
                  },
                  "& .MuiInputLabel-root": {
                    opacity: fromDate || params.focused ? 0 : 1,
                    transition: "opacity 0.3s",
                    top: "-16px",
                  },
                  "& .MuiInputLabel-shrink": {
                    display: "none",
                  },
                }}
              />
            ),
          }}
          disableFuture
          format="DD/MM/YYYY"
        />
        {toDate && (
          <IconButton
            size="small"
            onClick={clearToDate}
            sx={{
              position: "absolute",
              top: "50%",
              right: "40px",
              transform: "translateY(-50%)",
              background: "transparent",
              zIndex: 2,
            }}
          >
            <ClearIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
